export default "__VITE_PUBLIC_ASSET__6f7fbb7b__"